import React, { useState, useEffect } from "react";
import {
    Dialog,
    Classes,
    InputGroup,
    TextArea,
} from "@blueprintjs/core";
import { ErrorToaster, SuccessToaster } from "./../../utils/toaster";
import { POST, PUT, TenantID, GET } from "./../dataSaver";
import style from "./index.module.scss";
import CrossPink from "./../../images/crossPink.png";
import CommonInputField from '../../Components/CommonFields/CommonInputField';
import CommonCheckBox from '../../Components/CommonFields/CommonCheckBox';
import CommonSwitch from '../../Components/CommonFields/CommonSwitch';
import CommonTextField from '../../Components/CommonFields/CommonTextField';
import CommonLabel from '../../Components/CommonFields/CommonLabel';
import CommonSelectField from '../../Components/CommonFields/CommonSelectField';

const AddChiefStaffActivity = ({
    getAddChiefStaffActivityDialog,
    isEdit,
    getChiefStaffActivityData,
    regionsData,
    selectedActivity,
    activity,
    contractedServiceType
}) => {
    const [chiefStaffActivity, setChiefStaffActivity] = useState({
        activity: '',
        podRequired: false,
        schedule: 'WEEK',
        billable: false,
        asNeeded: false,
        activityDescription: '',
    });

    console.log(chiefStaffActivity);
    useEffect(() => {
        if (isEdit) {
            setChiefStaffActivity(selectedActivity)
        }
    }, [isEdit, selectedActivity]);

    const handleChiefStaffActivity = (name, value) => {
        if (name === 'schedule' && value !== 'NA') {
            setChiefStaffActivity({ ...chiefStaffActivity, [name]: value, asNeeded: false })
        } else if (name === 'schedule' && chiefStaffActivity?.asNeeded) {
            setChiefStaffActivity({ ...chiefStaffActivity, [name]: "NA" });
        } else {
            setChiefStaffActivity({ ...chiefStaffActivity, [name]: value });
        }
    }

    const activityToAdd = async () => {
        if (chiefStaffActivity?.activity === '') {
            ErrorToaster('Chief Staff Service Name is Mandatory');
            return;
        }
        if (contractedServiceType?.[1]?.defaultValue === "true" && chiefStaffActivity?.activityDescription === '') {
            ErrorToaster('Chief Staff Service Description is Mandatory');
            return;
        }
        if (!isEdit && activity?.map(data => data?.activity).includes(chiefStaffActivity?.activity)) {
            ErrorToaster('Chief Staff Service Name Already Exists');
            return;
        }
        let data = {
            ...(isEdit && { "id": chiefStaffActivity?.id }),
            "activity": chiefStaffActivity?.activity,
            "tenant": {
                "id": TenantID
            },
            "podRequired": chiefStaffActivity?.podRequired,
            "schedule": chiefStaffActivity?.schedule,
            "billable": chiefStaffActivity?.billable,
            "asNeeded": chiefStaffActivity?.asNeeded,
            "activityDescription": chiefStaffActivity?.activityDescription,
        }
        if (!isEdit) {
            await POST(`contract-managment-service/contracts/chiefStaffService`, data)
                .then(response => {
                    SuccessToaster('Activity Added to List');
                })
                .catch(error => {
                    ErrorToaster('Adding Activity To List Failed');
                })
        } else {
            await PUT(`contract-managment-service/contracts/chiefStaffService/${chiefStaffActivity?.id}`, data)
                .then(response => {
                    SuccessToaster('Activity Updated');
                })
                .catch(error => {
                    ErrorToaster('Updating Activity Failed');
                })
        }

        getAddChiefStaffActivityDialog(false)
    }

    return (
        <Dialog
            isOpen={getAddChiefStaffActivityDialog}
            onClose={() => getAddChiefStaffActivityDialog(false)}
            className={`${style.healthCareDialogStyle} ${style.dialogPaddingBottom}`}
        >
            <div
                className={`${Classes.DIALOG_BODY} ${style.extensionDialogBackground}`}
            >
                <div className={style.spaceBetween}>
                    <p className={style.extensionStyle}>
                        {isEdit ? "Edit" : "Add"} Chief Staff Activity
                    </p>
                    <img
                        src={CrossPink}
                        alt=""
                        className={`${style.colorFileStyle2} ${style.marginLeft20}`}
                        onClick={() => getAddChiefStaffActivityDialog(false)}
                    />
                </div>
                <div className={`${style.addonAddBox} ${style.marginTop20}`}>
                    <div className={`${style.addManagerGrid}`}>
                        <CommonLabel value='Chief Staff Services Name' />
                        <CommonInputField placeholder='Chief Staff Service Name' className={style.fullWidth} value={chiefStaffActivity?.activity} onChange={(e) => handleChiefStaffActivity('activity', e.target.value)} />
                    </div>
                    {
                        contractedServiceType?.[1]?.defaultValue === "true" &&
                        <div className={`${style.addManagerGrid}`}>
                            <CommonLabel value='Chief Staff Service Description' />
                            <TextArea rows={3} placeholder="Enter Description" value={chiefStaffActivity?.activityDescription} onChange={(e) => handleChiefStaffActivity('activityDescription', e.target.value)}
                            />
                        </div>
                    }

                    <div className={`${style.addManagerGrid} ${style.marginTop20}`}>
                        <CommonLabel value='Classify As Billable Activity' />
                        <div className={`${style.threeFieldWidth} `}>
                            <CommonSwitch label={chiefStaffActivity?.billable ? 'YES' : 'NO'} className={`${style.switchFontStyle} ${style.flexLeft} ${style.textAlignLeft}`} checked={chiefStaffActivity?.billable} onChange={(e) => handleChiefStaffActivity('billable', !chiefStaffActivity?.billable)} />
                        </div>
                    </div>

                    <div className={`${style.addManagerGrid} ${style.marginTop20}`}>
                        <CommonLabel value='Proof Of Completion / Documentation Required' />
                        <div className={style.displayInRow}>
                            <div className={`${style.threeFieldWidth} `}>
                                <CommonSwitch label={chiefStaffActivity?.podRequired ? 'YES' : 'NO'} className={`${style.switchFontStyle} ${style.flexLeft} ${style.textAlignLeft}`} checked={chiefStaffActivity?.podRequired} onChange={(e) => handleChiefStaffActivity('podRequired', !chiefStaffActivity?.podRequired)} />
                            </div>
                            <div className={style.threeFieldWidth}>
                                <CommonLabel value='Frequency*' />
                                <CommonSelectField className={`${style.fullWidth}`}
                                    value={chiefStaffActivity?.schedule || ''}
                                    onChange={(e) => handleChiefStaffActivity('schedule', e.target.value)}
                                    firstOptionLabel={'Select Frequency'} firstOptionValue={''}
                                    valueList={['NA', 'WEEK', 'MONTH', 'YEAR']}
                                    labelList={['NA', 'Per Week', 'Per Month', 'Per Year']}
                                    disabledList={[false, false, false, false, false]} />
                            </div>
                            <div className={`${style.marginTop20} ${style.marginLeft20}`}>
                                <CommonCheckBox checked={chiefStaffActivity?.asNeeded} label='As Needed' onChange={(e) => setChiefStaffActivity({ ...chiefStaffActivity, asNeeded: e.target.checked, schedule: 'NA' })} />
                            </div>

                        </div>
                    </div>

                    <div>
                        <div className={`${style.twoCol} ${style.marginTop20}`}>
                            <button className={`${style.outlinedButton} ${style.fullWidth}`} onClick={(e) => { getAddChiefStaffActivityDialog(false); }}>CANCEL</button>
                            <button className={`${style.buttonStyle} ${style.fullWidth}`} onClick={(e) => { activityToAdd() }}>SAVE</button>
                        </div>
                        <br />
                    </div>
                </div>

            </div>
        </Dialog>
    );
};

export default AddChiefStaffActivity;
